// ATE-CR-117
import type { ComponentType } from "react";

import {
  AlertTriangle,
  Building2,
  CreditCard,
  Home,
  Package,
  Palette,
  Settings,
  Shield,
  Ticket,
  Users,
} from "lucide-react";

import {
  ROUTE_ESCALATIONS,
  ROUTE_HOME,
  ROUTE_OPERATORS,
  ROUTE_SERVICE_REQUESTS,
  ROUTE_SYSTEM_CONFIG,
  ROUTE_TENANT_BRAND,
  ROUTE_TENANT_CREDITS,
  ROUTE_TENANT_ROLES,
  ROUTE_TENANT_USERS,
  ROUTE_TENANTS,
  ROUTE_THEMES,
} from "./routes";

export interface NavItem {
  readonly label: string;
  readonly to: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly icon: ComponentType<any>;
  readonly end?: boolean;
}

// ATE-CR-117: HQ scope menu — operator in "Atelier Admin" context.
// Spec D3: Home, Themes, Escalations (new), Service Requests, Operators, System Config.
// ATE-CR-159: Verify Email lives under System Config (linked from the SystemConfigPage)
// rather than as a top-level nav entry, per user direction.
export const NAV_HQ: readonly NavItem[] = [
  { label: "Home", to: ROUTE_HOME, icon: Home, end: true },
  { label: "Themes", to: ROUTE_THEMES, icon: Package },
  { label: "Escalations", to: ROUTE_ESCALATIONS, icon: AlertTriangle },
  { label: "Service Requests", to: ROUTE_SERVICE_REQUESTS, icon: Ticket },
  { label: "Operators", to: ROUTE_OPERATORS, icon: Users },
  { label: "System Config", to: ROUTE_SYSTEM_CONFIG, icon: Settings },
];

// ATE-CR-117: Tenant scope menu — operator in a specific tenant's context.
// Spec D3: Home, Tenants overview, Users, Roles, Credits, Brand, Themes, Service Requests.
export const NAV_TENANT: readonly NavItem[] = [
  { label: "Home", to: ROUTE_HOME, icon: Home, end: true },
  { label: "Tenants overview", to: ROUTE_TENANTS, icon: Building2 },
  { label: "Users", to: ROUTE_TENANT_USERS, icon: Users },
  { label: "Roles", to: ROUTE_TENANT_ROLES, icon: Shield },
  { label: "Credits", to: ROUTE_TENANT_CREDITS, icon: CreditCard },
  { label: "Brand", to: ROUTE_TENANT_BRAND, icon: Palette },
  { label: "Themes", to: ROUTE_THEMES, icon: Package },
  { label: "Service Requests", to: ROUTE_SERVICE_REQUESTS, icon: Ticket },
];
